import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { useLocation } from "react-router-dom";

import { DataRateContainer } from "../../components";
import { useGetDashboardSummary } from "../../hooks";
import { getStatCards } from "./helper";

export const DashboardOverview = ({ filters, period }) => {
  const { search } = useLocation();

  const {
    data: summary = {},
    isLoading,
    refetch,
  } = useGetDashboardSummary({ ...filters, period });

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  const metrics = getStatCards(summary);

  return (
    <Stack direction="row" gap="10px" flexWrap="wrap">
      {metrics.map((card) => (
        <DataRateContainer
          key={card.label}
          sx={{ flex: 1, minWidth: 180 }}
          {...card}
        />
      ))}
    </Stack>
  );
};

export default DashboardOverview;
